<template>
  <div class="select-container override white">
    <select clearable multiple v-model="selectedCategories">
      <option value="" disabled>
        {{ $store.state.user.langEng ? "Category" : "Kategori" }}
      </option>
      <option
        v-for="category in categories"
        :key="category.id"
        :value="category.name"
      >
        {{ category.name }}
      </option>
    </select>
    <div class="clear-icon">
      <i class="material-icons" @click="clearCategories">clear</i>
    </div>
    <!-- <div class="chips">
      <input />
    </div> -->
  </div>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { Api } from "@/utils";

@Component()
export default class SearchCategory extends Vue {
  searchInput = "";
  selectedCategories = [];
  categories = [];

  clearCategories() {
    this.selectedCategories = [];
    this.updateCategories();
  }

  @Watch("selectedCategories")
  filterOnCategories(updatedArray) {
    this.$store.commit("setSelectedCategories", updatedArray);
  }

  @Watch("$store.state.article.selectedCategories")
  onStoreCategories(updatedArray) {
    this.selectedCategories = updatedArray;

    // let elems = document.querySelector(".chips");
    // let chips = this.$M.Chips.getInstance(elems);
    // updatedArray.forEach((element) => {
    //   chips.addChip({ tag: element });
    // });

    let e = document.querySelector(".select-dropdown");
    e.value = updatedArray.join(", ");

    // Uncommenting the following line causes the drop down to close. Haven't noticed any drawbacks to commenting it out, yet...
    // this.updateCategories();
  }

  updateCategories() {
    setTimeout(() => {
      let elems = document.querySelectorAll("select");
      this.$M.FormSelect.init(elems);
    }, 10);
  }

  async created() {
    const klassName = this.$store.getters.classNameInUrl;
    const klassCategories = await Api.get(`klass-categories/${klassName}`, {
      properties: { order: "ASC" },
    });
    this.categories = klassCategories;
    this.updateCategories();
  }

  mounted() {
    // Initialize the chips and set delete handler

    // let elems = document.querySelectorAll(".chips");
    // this.$M.Chips.init(elems, {
    //   onChipDelete: (chip) => {
    //     console.log(chip);
    //     let chips = this.$M.Chips.getInstance(document.querySelector(".chips"));
    //     console.log("chips:", chips);
    //   },
    // });

    // document.querySelector(".chips").addEventListener("click", (e) => {
    //   let closeIcon = e.target.closest("i");
    //   if (closeIcon) {
    //     let chip = e.target.closest(".chip");
    //     let deleted = chip.innerText.replaceAll(/(close)$/g, "");
    //     this.selectedCategories = this.selectedCategories.filter(
    //       (e) => e != deleted
    //     );

    // console.log("Pressed the close icon...");
    // let chip = e.target.closest(".chip");
    // console.log(
    //   "chip:",
    //   chip,
    //   "innerText:",
    //   chip.innerText.replaceAll(/(close)$/g, "")
    // );
    // console.log(e.target);
    // });

    // let chips = this.$M.Chips.getInstance(document.querySelector(".chips"));
    // chips.addChip({
    //   tag: "chip 1",
    // });

    this.updateCategories();
  }
}
</script>

<style scoped lang="scss">
.select-container {
  align-items: center !important;
  border-radius: 5px;
  display: grid;
  grid-template-columns: auto 20px;
  grid-auto-rows: minmax(auto, 32px);
  padding: 0 1em !important;
  margin: 0.25em 0;
  .clear-icon {
    justify-content: center !important;
    i {
      cursor: pointer;
      margin-top: 5px;
    }
    i:hover {
      color: grey;
    }
    i:active {
      color: grey;
      font-size: 1.5em;
    }
  }
}
</style>
